<template>
    <v-card v-if="showTile">
        <v-layout row wrap class="directory-block-header">
            <v-flex xs6>
                <v-flex tag="h2">
                    <span data-qe-id="directory_section">{{constants.BLOCK_TITLE}}</span>
            <v-flex v-if="showMemberCount">
                <small v-if="memberCount" data-qe-id="community-officer_member-count">
                    {{constants.MEMBER_COUNT_PRE_TEXT}} ({{memberCount}})
                </small>
            </v-flex>
                </v-flex>
                </v-flex>
                <v-flex xs6 class="download-directory" v-if="showDownloadDirectory" >
                    <span class="d-block">{{constants.MEMBER_DOWNLOAD_TEXT}}</span>
            <v-flex v-if="memberCount">
                <strong data-qe-id="community-officer_member-count">
                    <a @click="downloadDirectory('csv')"
                               data-qe-id="download-directory_csv_link">
                                <strong>{{constants.CSV_DOWNLOAD_TEXT}}</strong>
                            </a>
                            /
                    <a @click="downloadDirectory('xlsx')"
                               data-qe-id="download-directory_excel_link">
                                <strong>{{constants.EXCEL_DOWNLOAD_TEXT}}</strong>
                            </a>
                </strong>
            </v-flex>
                </v-flex>
        </v-layout>
        <v-layout column class="directory-block">
            <status-overlay :action="loadAction"></status-overlay>

            <v-layout row wrap v-if="forumCommunityTitle !== communityCommonConstant.CommunityOfficer.TYPE_FORUM">
                <v-flex class="directory-block__row" v-for="(officer, index) in primaryOfficersList" :key="`forum_${officer.id}-${index}`">
                    <v-avatar><img :src="sizeFormattedImageUrl(officer.profileImageUrl, 150, 150)"
                        :onerror="imageErrorFallback(sizeFormattedImageUrl(officer.fallbackProfileImageUrl, 150, 150))"/>
                    </v-avatar>
                        <v-flex xs12 class="directory-block__info">
                            <a @click="openMemberProfile(officer.id)"
                               :data-qe-id="`community-officer_${index}_profile_link`">
                                <strong :data-qe-id="`community-officer_${index}_name`">{{officer.fullName}}</strong>
                            </a>
                            <small :data-qe-id="`community-officer_${index}_title`">{{getOfficerTitles(officer)}}</small>
                        </v-flex>
                        <v-layout row wrap>
                            <v-flex text-xs-right v-if="isCommunityAdmin && isChapterPage && currentCommunityView === userRoles.ADMIN">
                                <a @click="openLink(`${salesforceURL}${officer.personSalesForceId}`)"
                                   :data-qe-id="`community-officer_${index}_sales-force_link`">
                                    {{constants.MANAGE_IN_SALESFORCE}}</a>
                            </v-flex>
                        </v-layout>
                </v-flex>
            </v-layout>

            <v-expansion-panel v-if="expansionPanelVif">
                <v-expansion-panel-content v-if="expandedViewList">
                    <div slot="header" class="panel-heading" data-qe-id="community-officer_expansion-panel">
                        {{headerText}}
                        <small>({{expandedViewList.length}})</small>
                    </div>

                    <v-flex class="directory-block__row" v-for="(officer, index) in expandedViewList" :key="`expanded_${officer.id}-${index}`">
                        <v-avatar><img :src="sizeFormattedImageUrl(officer.profileImageUrl, 150, 150)"
                            :onerror="imageErrorFallback(sizeFormattedImageUrl(officer.fallbackProfileImageUrl, 150, 150))"/>
                        </v-avatar>
                            <v-flex xs12 class="directory-block__info">
                                <a @click="openMemberProfile(officer.id)"
                                   :data-qe-id="`community-officer_${index}_profile_link`">
                                    <strong :data-qe-id="`community-officer_${index}_name`">{{officer.fullName}}</strong>
                                </a>
                                 <small :data-qe-id="`community-officer_${index}_title`"> {{getOfficerTitles(officer)}}</small>
                            </v-flex>
                            <v-layout row wrap>
                                <v-flex text-xs-right
                                        v-if="isCommunityAdmin && isChapterPage && currentCommunityView === userRoles.ADMIN">
                                    <a @click="openLink(`${salesforceURL}${officer.personSalesForceId}`)"
                                       :data-qe-id="`community-officer_${index}_sales-force_link`">
                                        {{constants.MANAGE_IN_SALESFORCE}}
                                    </a>
                                </v-flex>
                            </v-layout>
                    </v-flex>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-layout column v-if="detailVif">
                <v-flex class="directory-block__row" v-for="(officer, index) in expandedViewList" :key="`detail_${officer.id}-${index}`">
                    <v-avatar><img :src="sizeFormattedImageUrl(officer.profileImageUrl, 150, 150)"
                            :onerror="imageErrorFallback(sizeFormattedImageUrl(officer.fallbackProfileImageUrl, 150, 150))"/>
                </v-avatar>
                        <v-flex xs12 class="directory-block__info">
                            <a @click="openMemberProfile(officer.id)"
                               :data-qe-id="`community-officer_${index}_profile_link`">
                                <strong :data-qe-id="`community-officer_${index}_name`">{{officer.fullName}}</strong>
                            </a>
                            <small :data-qe-id="`community-officer_${index}_title`"> {{getOfficerTitles(officer)}}</small>
                        </v-flex>
                        <v-layout row wrap>
                            <v-flex text-xs-right v-if="isCommunityAdmin && isChapterPage && currentCommunityView === userRoles.ADMIN">
                                <a @click="openLink(`${salesforceURL}${officer.personSalesForceId}`)"
                                   :data-qe-id="`community-officer_${index}_sales-force_link`">
                                    {{constants.MANAGE_IN_SALESFORCE}}
                                </a>
                            </v-flex>
                        </v-layout>
                </v-flex>
            </v-layout>
            <v-layout row wrap v-if="viewDirectoryVif">
                <v-flex xs12 text-xs-right>
                    <v-btn xs12 class="primary_btn small transparent"
                           data-qe-id="community-directory_view-all-members_link"
                           @click="viewAll">
                        {{constants.VIEW_DIRECTORY_LINK}}
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-layout>
    </v-card>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';
    import { storeAction } from '../../store/storeActions.constant';
    import { storeGetters } from '../../store/storeGetters.constant';
    import { communityCommonConstant, createFilterFromCommunityData } from '../ChapterPage/communityCommon.constant';
    import StatusOverlay from '../StatusOverlay/StatusOverlay';
    import { routerNames, userRoles, capitalize } from "../appCommon.constants";
    import { imageErrorFallback } from "../../common/utils/utils";
    import { gaDataLayerEvent } from "@/plugins/analytics";
    import { gtmEventName } from "@/plugins/gtmAnalytics";
    import { sizeFormattedImageUrl } from "@/common/utils/cloudinaryUtils";

    export default {
        name: 'CommunityOfficersList',
        components: {
            StatusOverlay,
        },
        data() {
            return {
                userRoles,
                routerNames,
                communityCommonConstant,
                sizeFormattedImageUrl,
            };
        },
        created() {
            this.getChapterOfficersData();
            this.getIsPMTeamMember();
            this.$watch(
                () => this.$store.getters[storeGetters.communityIdPromise],
                () => this.getChapterOfficersData(),
                () => this.getIsPMTeamMember(),
            );
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                [storeGetters.chapterOfficersData]: `chapter/${storeGetters.chapterOfficersData}`,
                [storeGetters.salesforceURL]: `${storeGetters.salesforceURL}`,
                isCommunityAdmin: `chapter/${storeGetters.getIsCommunityAdmin}`,
                communityInfo: `chapter/${storeGetters.communityInfo}`,
                currentCommunityView: `${storeGetters.currentCommunityView}`,
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                chapterAdmin: `memberProfile/${storeGetters.chapterAdmin}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                isPMTeamMember: `chapter/${storeGetters.isPMTeamMember}`,
            }),
            expansionPanelVif() {
                return this.chapterOfficersData && this.chapterOfficersData.canViewOfficersList && this.expandedViewList && this.expandedViewList.length > 0 &&
                    this.forumCommunityTitle !== communityCommonConstant.CommunityOfficer.TYPE_FORUM;
            },
            detailVif() {
                return this.chapterOfficersData && this.chapterOfficersData.canViewOfficersList && this.expandedViewList && this.expandedViewList.length > 0 &&
                    this.forumCommunityTitle === communityCommonConstant.CommunityOfficer.TYPE_FORUM;
            },
            viewDirectoryVif() {
                return this.memberCount && this.memberCount > 0 && this.chapterOfficersData.canViewDirectoryLinks &&
                    this.forumCommunityTitle !== communityCommonConstant.CommunityOfficer.TYPE_FORUM;
            },
             showMemberCount() {
                return this.memberCount && this.memberCount > 0 && this.chapterOfficersData.canViewMemberCount;
            },
            forumCommunityTitle() {
                return capitalize(this.$store.getters[storeGetters.communityName]);
            },
            showTile() {
                return this.chapterOfficersData && (this.chapterOfficersData.canViewDiretory || this.chapterOfficersData.members > 0);
            },
            showDownloadDirectory() {
                return this.isPMTeamMember;
            },
            isChapterPage() {
                return this.$route.name === routerNames.CHAPTER;
            },
            isNetworkPage() {
                return this.$route.name === routerNames.NETWORK;
            },
            loadAction() {
                return this.actions[storeAction.getChapterOfficersData];
            },
            constants() {
                return communityCommonConstant.CommunityOfficer;
            },
            headerText() {
                if (this.$route.name.toLowerCase() === this.routerNames.REGION.toLowerCase()) {
                    return communityCommonConstant.CommunityOfficer.REGIONAL_OFFICERS_PRE_TEXT;
                }
                return capitalize(this.$route.name).concat(communityCommonConstant.CommunityOfficer.OFFICERS);
            },
            memberCount() {
                let count = 0;
                if (this.chapterOfficersData) {
                    count = this.chapterOfficersData.members;
                }
                return count;
            },
            primaryOfficersList() {
                if (this.chapterOfficersData && this.chapterOfficersData.primaryOfficers) {
                    const communityPrimaryOfficers = this.chapterOfficersData.primaryOfficers;
                    return communityPrimaryOfficers;
                }
            },
            expandedViewList() {
                if (this.isNetworkPage && this.chapterOfficersData && this.chapterOfficersData.otherOfficers) {
                    return this.chapterOfficersData.otherOfficers;
                }
                return this.allOfficersList;
            },
            allOfficersList() {
                if (this.chapterOfficersData && this.chapterOfficersData.otherOfficers) {
                    if(this.forumCommunityTitle === communityCommonConstant.CommunityOfficer.TYPE_FORUM) {
                       return this.primaryOfficersList.concat(this.chapterOfficersData.otherOfficers)
                    }
                    return this.chapterOfficersData.otherOfficers;
                }
            },
        },
        methods: {
            ...mapActions({
                [storeAction.getChapterOfficersData]: `chapter/${storeAction.getChapterOfficersData}`,
                getChapterAdmin: `memberProfile/${storeAction.getChapterAdmin}`,
                [storeAction.getDownloadMemberDirectory]: `chapter/${storeAction.getDownloadMemberDirectory}`,
                [storeAction.getIsPMTeamMember]: `chapter/${storeAction.getIsPMTeamMember}`,
            }),
            imageErrorFallback,
            viewAll() {
                if (this.communityInfo) {
                    const filterData = createFilterFromCommunityData(this.communityInfo);
                    gaDataLayerEvent(gtmEventName.C_Community_Page_View_All_Members, this.communityInfo.communityId);
                    this.$router.push({
                        path: `/memberDirectoryPage`,
                        query: {
                            navigatedFromId: this.communityInfo && this.communityInfo.communityId
                                ? this.communityInfo.communityId
                                : null,
                            filters: JSON.stringify(filterData),
                        },
                    });
                }
            },
            openLink(link) {
                window.open(link, '_blank');
                return false;
            },
            openMemberProfile(officerId) {
                if (this.currentUserId === officerId) {
                  gaDataLayerEvent(gtmEventName.C_Community_Page_Member_Selected, officerId);
                    this.$router.push({
                        path: '/memberProfile',
                        query: {
                            memberId: officerId,
                            name: this.communityInfo && this.communityInfo.name && !this.$route.name.includes('home')
                                ? this.communityInfo.name
                                : this.communityCommonConstant.YPO_HOME,
                            mode: this.routerNames.EDIT,
                        },
                    });
                } else {
                    this.getChapterAdmin(officerId)
                    .then(() => {
                        if (this.chapterAdmin) {
                          gaDataLayerEvent(gtmEventName.C_Community_Page_Member_Selected, officerId);
                            this.$router.push({
                                path: '/memberProfile',
                                query: {
                                    memberId: officerId,
                                    name: this.communityInfo && this.communityInfo.name && !this.$route.name.includes('home')
                                        ? this.communityInfo.name
                                        : this.communityCommonConstant.YPO_HOME,
                                    mode: this.routerNames.EDIT,
                                },
                            });
                        } else {
                          gaDataLayerEvent(gtmEventName.C_Community_Page_Member_Selected, officerId);
                            this.$router.push({
                                path: '/memberProfile',
                                query: {
                                    memberId: officerId,
                                    name: this.communityInfo && this.communityInfo.name && !this.$route.name.includes('home')
                                        ? this.communityInfo.name
                                        : this.communityCommonConstant.YPO_HOME,
                                },
                            });
                        }
                    });
                }
            },
            downloadDirectory(downloadType) {
                this.getDownloadMemberDirectory(downloadType);
            },
          getOfficerTitles(officer) {
              if (officer && officer.positionTitles && officer.positionTitles.length) {
                return officer.positionTitles.join(" | ");
              }
              return "";
          },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
.directory-block-header {
    border-bottom: 1px solid rgba($ypo-gray, 0.4);
    padding: 8px 15px;
    align-items: center;
    h2 {
        padding: 0;
        border: none;
        line-height: normal;
    }
    .download-directory {
        font-style: italic;
        font-weight: 500;
        line-height: 17px;
        font-family: Raleway, serif;
        span {
            color: $ypo-cta;
        }
    }
}
    .directory-block {
        position: relative;

        &__row {
            position: relative;
            padding: 15px 0px;
            border-bottom: 1px solid $ypo-medium-gray;
            min-height: 40px;
            margin: 0 15px;
            .v-avatar {
                position: absolute;
                left: 0;
                top: 10px;
            }
        }

        &__info {
            padding-left: 60px;

            strong {
                display: block;
                color: $ypo_blue;
                font-size: 14px;
                font-weight: bold;
                letter-spacing: 0.22px;
                line-height: 18px;
            }

            small {
                color: $ypo-cta;
                font-size: 12px;
                letter-spacing: -0.1px;
                line-height: 20px;
            }
        }

        .v-expansion-panel {
            box-shadow: none;

            &__container {
                border-bottom: 1px solid $ypo-medium-gray;
                margin: 0 15px;
                flex: auto;
                position: relative;

                &--active {
                    background: $ypo-extra-light-gray;
                    padding-bottom: 15px;
                    border-bottom: none;

                    &:after {
                        transform: rotate(90deg);
                    }
                }
            }
        }

        .panel-heading {
            padding: 0;
            color: $ypo_blue;
            font-size: 14px;
            line-height: 18px;
            margin-left: -15px;
            position: relative;

            small {
                position: absolute;
                right: 15px;
                font-size: 14px;
            }
        }
    }
</style><style lang="scss">
    .directory-block {

        /* Alter the rotation of the header icon */
        .v-expansion-panel__header__icon {
            margin-right: -15px;
            transform: rotate(-90deg);
            transition: transform 0.1s linear;
        }

        .v-expansion-panel__container--active .v-expansion-panel__header__icon {
            transform: rotate(0deg);
        }
    }
</style>
